import SvgArrowLeft from 'src/components/icons/arrow-left-v2-2x';
import SvgArrowRight from 'src/components/icons/arrow-right-v2';
import SvgVideo from 'src/components/icons/video';
import SvgMusic from 'src/components/icons/music';
import SvgIcMusicrecord from 'src/components/icons/ic-music-record';
import { useState, ReactNode } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PreloadImg from 'src/components/common/preload-img/preload-img';
import { Box, Image } from '@chakra-ui/react';
import { useIsMobile } from 'src/hooks/use-is-mobile';

interface IMedia {
  type: string;
  coverUrl: string;
}

interface Props {
  media: Array<IMedia>;
  menu?: ReactNode;
  className?: string;
}
const Media = ({ media, menu, className = '' }: Props) => {
  const [active, setActive] = useState(0);
  const activeMedia = media[active];
  const isMobile = useIsMobile();

  const activeHandle = (direction) => {
    const offect = direction === 'left' ? -1 : 1;
    let activeNext = active + offect;
    if (activeNext < 0) activeNext = 0;
    else if (activeNext >= media.length) activeNext = media.length - 1;
    setActive(activeNext);
  };
  return (
    <Box className={`relative ${className} h-50`}>
      {media.length > 1 && (
        <Box className="absolute z-10 left-4 top-4 text-gray-300 text-sm">
          <span
            className={`${active > 0 ? 'text-white' : ''} cursor-pointer`}
            aria-hidden="true"
            onClick={() => activeHandle('left')}
          >
            <SvgArrowLeft className="inline mr-1" />
          </span>
          <span className="text-white ">
            {active + 1 < 10 ? `0${active + 1}` : active}{' '}
          </span>
          / {media.length < 10 ? `0${media.length}` : media.length}
          <span
            className={`${
              active < media.length - 1 ? 'text-white' : ''
            } cursor-pointer`}
            aria-hidden="true"
            onClick={() => activeHandle('right')}
          >
            <SvgArrowRight className="inline  ml-1" />
          </span>
        </Box>
      )}

      <TransitionGroup
        className={`relative ${className === 'bg-gray-900' && 'w-full h-full'}`}
      >
        <CSSTransition key={active} timeout={500} classNames="fade-in">
          <>
            {menu && isMobile && (
              <Box
                position="absolute"
                zIndex="100"
                w="100%"
                textAlign="end"
                p="16px"
              >
                {menu}
              </Box>
            )}

            {activeMedia.type === 'img' && activeMedia.coverUrl !== '' && (
              <Image
                borderRadius={{ base: '4px', md: '0' }}
                className="absolute object-cover h-50 w-full"
                alt=""
                src={activeMedia.coverUrl}
              />
            )}
            {activeMedia.type === 'img' &&
              activeMedia.coverUrl === '' &&
              className !== 'bg-gray-900' && <PreloadImg height={200} />}
            {activeMedia.type === 'img' &&
              activeMedia.coverUrl === '' &&
              className === 'bg-gray-900' && (
                <SvgIcMusicrecord
                  className="absolute inset-0 m-auto"
                  boxSize={38}
                />
              )}
            {activeMedia.type === 'video' && (
              <>
                <div className="absolute z-20 text-white right-4 top-4">
                  <SvgVideo width={20} height={20} />
                </div>
                <Image
                  borderRadius={{ base: '4px', md: '0' }}
                  className="absolute object-cover h-50"
                  alt=""
                  src={activeMedia.coverUrl}
                />
              </>
            )}
            {activeMedia.type === 'music' && (
              <>
                <div className="absolute z-20 text-white right-4 top-4">
                  <SvgMusic width={20} height={20} />
                </div>
                <Image
                  borderRadius={{ base: '4px', md: '0' }}
                  className="absolute object-cover h-50"
                  alt=""
                  src={activeMedia.coverUrl}
                />
              </>
            )}
          </>
        </CSSTransition>
      </TransitionGroup>
    </Box>
  );
};
export default Media;
